import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { ApplicationModule, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
    enableProdMode();
}

Sentry.init({
    dsn: 'https://ea214dc0d9824cf3b1d36e045b28d81e@o438224.ingest.sentry.io/4505980133900288',

    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
        'localhost',
        'sunology-stream-recette.emotic.fr',
        'sunology-stream-preprod.emotic.fr',
        'stream.sunology.eu',
    ],
    enabled: environment.production,
    environment: environment.env,
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
});

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch(err => {
    // Capacitor's console bridge doesn't reliably relay Error objects passed
    // directly to console.error() on-device (the message/stack get dropped,
    // leaving only a bare {"code": ...}) -- log the message/stack explicitly
    // so a bootstrap failure is actually diagnosable from device logs.
    console.error('bootstrapApplication failed:', err?.message ?? err, err?.stack);
});
